import {css} from '../theme/css'

export const classes = {
  root: css`
    width: 100%;
    height: 100%;
  `,
}
